<style scoped>
  .management-plan-label {
    margin-bottom:0px;
    margin-top:10px;
  }
  .management-plan-overlay {
    min-height:480px;
  }
  .property-description-tab {
    padding-top:20px;
    margin-bottom:20px;
  }
  .form-group label {
      width: 150px;
  }
</style>
<!-- eslint-disable max-len -->
<template>
  <div class='view-contents'>
    <b-overlay :show="formLoading" class='management-plan-overlay'>
      <b-card no-body>
        <b-tabs
          card
          align="center"
          @activate-tab="activateTab">
          <b-tab v-for="(section) in schema" :key="section.legend" :title="section.legend" class="tabbed-form-header">
            <b-card-body class='site-section-wrapper'>
              <b-alert
                :show="successDismissCountDown"
                dismissible
                variant="success"
                @dismissed="successDismissCountDown=0"
                @dismiss-count-down="successCountDownChanged"
              >
                Management Plan saved successfully.
              </b-alert>
              <b-alert :show="submitError" dismissible variant="danger">
                <p>There were errors in submitting this Management Plan</p>
                <p>{{submitError}}</p>
              </b-alert>
              <b-alert
                :show="!activeTabValid"
                dismissible
                variant="danger"
              >
                Please fill in all required fields before saving or moving to another tab
              </b-alert>
              <div class="row section-header">
                <div class="col-12 bold-title">
                  {{ section.headerName }}
                  <b-button
                    pill
                    variant="primary"
                    size="sm"
                    class="submit-form-button"
                    @click="submitPlan(section)"
                    >
                      <template v-if="section.id === 'managementRecommendations'">
                        Submit
                      </template>
                      <template v-else>
                        Save
                      </template>
                  </b-button>
                  <b-button
                    v-if="section.id === 'unitDetails'"
                    pill
                    variant="danger"
                    size="sm"
                    class="submit-form-button"
                    @click="addNewUnit">
                    Add New
                  </b-button>
                </div>
              </div>
              <template v-if="section.id === 'unitDetails'">
                <!-- key is id or tempId and we are doing * 100 to avoid collisions -->
                <div
                  v-for="(currentUnit, index) in currentUnits"
                  :key="currentUnit.id ? currentUnit.id * 100  : currentUnit.tempId"
                  ref='unitInput'>
                  <VueFormGenerator
                    :schema="unitSchema"
                    :model="currentUnit"
                  />

                  <b-modal :id="`deleteUnitModal-${currentUnit.id || currentUnit.tempId}`" title="Confirm Unit Delete" @ok="deleteUnit(index)">
                    <div>Are you sure you want to delete this Unit?</div>
                    <template v-slot:modal-footer="{ ok, cancel }">
                      <b-button size="sm" variant="danger" @click="cancel" class='incentive-payments-dialog-no'>No</b-button>
                      <b-button size="sm" variant="success" @click="ok" class='incentive-payments-dialog-yes'>Yes</b-button>
                    </template>
                  </b-modal>
                </div>
                <div class="row">
                </div>
              </template>
              <template v-else-if="section.id =='managementRecommendations'">
                <div class="row">
                  <div class="col-6">
                  </div>
                  <div class="col-6">
                    <b-link class="add-link" @click="openPracticeModal">
                      <b-icon icon="plus"></b-icon>Add Practice
                    </b-link>
                  </div>
                </div>
                <b-modal id="practiceModal" title="New Practice" size="xl">
                  <p>
                    <VueFormGenerator
                      v-if="lookupsLoaded"
                      :schema="practiceSchema"
                      :model="currentPractice"
                      :options="formOptions"
                      @validated="onPracticeValidation"
                    />
                  </p>
                  <template v-slot:modal-footer>
                    <b-button size="sm" variant="danger" @click="cancelPractice" class='management-plan-dialog-no'>Cancel</b-button>
                    <b-button v-if="isNewPractice(currentPractice)"
                      :disabled="!validPracticeForm"
                      size="sm"
                      variant="success"
                      @click="addPractice"
                      class='management-plan-dialog-yes'>
                      Add Practice
                    </b-button>
                    <b-button v-else
                      :disabled="!validPracticeForm"
                      size="sm"
                      variant="success"
                      @click="updatePractice"
                      class='management-plan-dialog-yes'>
                      Update Practice
                    </b-button>
                  </template>
                </b-modal>
                <div v-if="currentVisiblePractices.length === 0">
                  No practices found.
                </div>
                <b-table id='practiceTable' striped :fields="practiceFields" :items="currentVisiblePractices" v-else-if="lookupsLoaded">
                  <template v-slot:cell(actions)="row">
                    <b-link @click="editPractice(row)" class="mr-1">
                      Edit
                    </b-link>|
                    <b-link variant="danger" @click="deletePractice(row)">
                      Delete
                    </b-link>
                  </template>
                </b-table>
              </template>
              <template v-else>
                <div class='property-description-tab vue-form-generator' v-if="section.id === 'propertyDescription'">
                  <div class='row'>Please review the Address, Tax Lots, Township, Range, Section and Quad details and make any needed changes on the site page in Insightly.</div>
                  <div v-for="(siteObject) in managementPlan.siteObjects" :key="siteObject.Id">
                    <div class='row'>
                      <a class='site-action-title' :href='`${config.insightly.siteUrl}${siteObject.Id}`' target='insightly'>{{siteObject.RecordName}}</a>
                    </div>
                    <div class='row form-group management-plan-label'><label>Address</label></div>
                    <div>{{siteObject.Site_Address__c}}</div>
                    <div>{{`${siteObject.City__c}, ${siteObject.State__c}`}}</div>
                    <div class='row form-group management-plan-label'><label>Tax Lot(s)</label></div>
                    <div v-for="(taxlotObject) in siteObject.taxlotObjects" :key="taxlotObject.recordId">
                      <a :href='`${config.insightly.siteTaxlotUrl}${taxlotObject.recordId}`' target='insightly'>
                        <span>{{taxlotObject.taxlotId}}</span>
                      </a>
                    </div>
                    <div class='row form-group management-plan-label' management-plan-label><label>Townships, Range, Section, Quarter(s)</label></div>
                    <div v-for="(trsObject) in siteObject.trsObjects" :key="trsObject.recordId">
                      <a :href='`${config.insightly.siteTRSUrl}${trsObject.recordId}`' target='insightly'>
                        <span>{{`T${trsObject.township} R${trsObject.range} Section ${trsObject.section} ${trsObject.quarter} 1/4`}}</span>
                      </a>
                    </div>
                  </div>
                </div>
                <VueFormGenerator
                  v-if="lookupsLoaded"
                  :schema="section"
                  :model="managementPlan"
                  :options="formOptions"
                />
                <div class='col-12 bold-title row section-header'>Associated Sites</div>
                <div v-if='config && managementPlan && managementPlan.sites'>
                  <div v-for="(site) in managementPlan.sites" :key='site.insightlyId'>
                    <div class='row details-row'>
                      <div class='col-2 details-label'>{{site.siteName}}</div>
                      <div class='col-10'>
                        <router-link :to="{ name: 'Site', params: { id: site.insightlyId } }">View in Acorn</router-link>
                        &nbsp;&nbsp;|&nbsp;&nbsp;
                        <a :href="getInsightlySiteUrl(site.insightlyId)" target='insightly'>View in Insightly</a>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </b-card-body>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-overlay>
  </div>
</template>
<script>
/* eslint-disable max-len, no-await-in-loop, no-loop-func, no-param-reassign, padded-blocks, prefer-destructuring */
import { mapState, mapGetters } from 'vuex';
import { loadModules } from 'esri-loader';
import api from '@/api';
import AlertManager from '@/mixins/AlertManager';
import ManagementPlanSchemaHelper from '../mixins/managementPlanSchemaHelper';

export default {
  name: 'ManagementPlanForm',
  mixins: [ManagementPlanSchemaHelper, AlertManager],
  computed: {
    ...mapState(['config']),
    ...mapState('ManagementPlan', {
      managementPlan: (state) => state.managementPlan,
      targetSeasons: (state) => state.targetSeasons,
      practiceTypes: (state) => state.practiceTypes,
      submitError: (state) => state.submitError,
      initialUnitDetails: (state) => state.initialUnitDetails,
    }),
    ...mapState('SiteAssessment', { tualatinContacts: (state) => state.tualatinContacts }),
    ...mapGetters('ManagementPlan', [
      'currentVisiblePractices',
    ]),
  },
  data() {
    return {
      schema: [],
      practiceSchema: {},
      unitSchema: {},
      currentPractice: {},
      currentUnits: [],
      lookupsLoaded: false,
      activeTabValid: true,
      validPracticeForm: false,
      formOptions: {
        validateAfterChanged: true,
      },
      practiceFields: [
        {
          key: 'practiceType',
          label: 'Practice',
          formatter: (value) => value.name,
        },
        {
          key: 'targetSeason',
          label: 'Target Season',
          formatter: (value) => {
            if (value) {
              return value.name;
            }
            return '';
          },
        },
        {
          key: 'targetYear',
          label: 'Target Year',
          formatter: (value) => value.getFullYear(),
        },
        {
          key: 'unitsFields',
          label: 'Unit(s)/Field(s)',
        },
        {
          key: 'acres',
          label: 'Acres',
        },
        {
          key: 'notes',
          label: 'Notes',
        },
        {
          key: 'actions',
          label: '',
        },
      ],
      formLoading: false,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    activateTab(newTabIndex, prevTabIndex, bvEvent) {
      this.hideSuccessAlert();
      if (prevTabIndex !== 0 || (prevTabIndex === 0 && this.checkRequiredPlanFields())) {
        this.activeTabValid = true;
        window.scrollTo(0, 0);
      } else {
        this.activeTabValid = false;
        window.scrollTo(0, 0);
        bvEvent.preventDefault();
      }
    },
    deleteUnit(index) {
      this.currentUnits.splice(index, 1);
    },
    checkRequiredPlanFields() {
      if (!this.managementPlan.basic.planName || this.managementPlan.basic.planName === '' || this.managementPlan.basic.planName.length < 3
        || !this.managementPlan.basic.author || this.managementPlan.basic.author === ''
        || !this.managementPlan.basic.planMonthYear) {
        return false;
      }
      return true;
    },
    onPracticeValidation(isValid, errors) {
      this.validPracticeForm = isValid;
      this.checkRequiredPracticeFields();
      console.debug(errors);
    },
    checkRequiredPracticeFields() {
      if (!this.currentPractice.practiceTypeId
        || !this.currentPractice.targetYear
        || !this.currentPractice.unitsFields || this.currentPractice.unitsFields === ''
        || !this.currentPractice.acres || Number.isNaN(this.currentPractice.acres)) {
        this.validPracticeForm = false;
      } else {
        this.validPracticeForm = true;
      }
    },
    load() {
      loadModules(
        ['esri/identity/IdentityManager', 'esri/layers/FeatureLayer'],
        { css: true },
      ).then((
        [IdentityManager, FeatureLayer],
      ) => {

        this.identityManager = IdentityManager;

        if (localStorage['acorn.identityManager']) {
          try {
            this.identityManager.initialize(localStorage['acorn.identityManager']);
          } catch (exception) {
            console.error('this.identityManager could not be initialized with localStorage[\'acorn.identityManager\']]');
          }
        }

        this.identityManager.on('credential-create', () => {
          try {
            localStorage['acorn.identityManager'] = JSON.stringify(this.identityManager.toJSON());
          } catch (exception) {
            console.error('localStorage[\'acorn.identityManager\'] could not be set with JSON.stringify(this.identityManager.toJSON())');
          }
        });

        this.siteLayer = new FeatureLayer({
          url: this.config.managementPlanForm.siteFeatureQueryUrl,
        });

        const type = this.$route.params.type ? this.$route.params.type : 'update';
        if (type === 'insert') {
          this.loadInsert();
        } else {
          this.loadUpdate();
        }
      });
    },
    loadInsert() {
      this.formLoading = true;

      const planPropertyDescription = this.managementPlan.propertyDescription;
      const configPropertyDescription = this.config.managementPlanForm.propertyDescription;

      planPropertyDescription.fireDistricts = configPropertyDescription.fireDistricts.join('\n');
      planPropertyDescription.nativeSeedZones = configPropertyDescription.nativeSeedZones.join('\n');
      planPropertyDescription.zoning = configPropertyDescription.zoning;

      const basic = this.managementPlan.basic;
      const introduction = this.managementPlan.introduction;
      const planType = this.managementPlan.planType;
      const propertyDescription = this.managementPlan.propertyDescription;
      const propertyOverview = this.managementPlan.propertyOverview;
      const resourceAnalysis = this.managementPlan.resourceAnalysis;
      const siteGraphics = this.managementPlan.sites.map((site) => site.graphic);

      this.$store.dispatch(
        'ManagementPlan/fetchManagementPlan',
        parseInt(this.$route.params.id, 10),
      ).then(() => {

        this.managementPlan.basic = basic;
        this.managementPlan.introduction = introduction;
        this.managementPlan.planType = planType;
        this.managementPlan.propertyDescription = propertyDescription;
        this.managementPlan.propertyOverview = propertyOverview;
        this.managementPlan.resourceAnalysis = resourceAnalysis;
        this.managementPlan.siteGraphics = siteGraphics;
        this.currentUnits = this.managementPlan.unitDetails;

        this.loadCoordinatesLatLong(this.managementPlan.siteGraphics).then((coordinatesLatLong) => {
          this.managementPlan.propertyDescription.coordinatesLatLong = coordinatesLatLong;
        });

        this.loadCoordinatesUTM(this.managementPlan.siteGraphics).then((coordinatesUTM) => {
          this.managementPlan.propertyDescription.coordinatesUTM = coordinatesUTM;
        });

        const insightlyIds = this.managementPlan.siteGraphics.map((siteGraphic) => siteGraphic.attributes.insightlyid);
        this.loadSiteObjects(this.managementPlan.siteGraphics).then(() => {
          this.handleLookups(insightlyIds);
          this.formLoading = false;
        }).catch((exception) => {
          this.formLoading = false;
          console.error('exception: ', exception);
        });
      }).catch((exception) => {
        this.formLoading = false;
        console.error('exception: ', exception);
      });
    },
    loadUpdate() {
      this.formLoading = true;

      this.$store.dispatch(
        'ManagementPlan/fetchManagementPlan',
        parseInt(this.$route.params.id, 10),
      ).then(() => {
        const insightlyIds = this.managementPlan.sites.map((site) => site.insightlyId);
        this.currentUnits = this.managementPlan.unitDetails;
        this.loadSiteGraphics(this.config.managementPlanForm.siteFeatureQueryUrl, insightlyIds).then(() => {
          this.loadSiteObjects(this.managementPlan.siteGraphics).then(() => {
            this.handleLookups(insightlyIds);
            this.formLoading = false;
          }).catch((exception) => {
            this.formLoading = false;
            console.error('exception: ', exception);
          });
        }).catch((exception) => {
          this.formLoading = false;
          console.error('exception: ', exception);
        });
      }).catch((exception) => {
        this.formLoading = false;
        console.error('exception: ', exception);
      });
    },
    handleLookups(insightlyIds) {
      this.loadLookups(insightlyIds).then(() => {
        this.lookupCleanup();
      }).catch((exception) => {
        console.error('exception: ', exception);
      });
    },
    lookupCleanup() {
      this.lookupsLoaded = true;
      if (this.managementPlan.planType === 'Agricultural Management Plan') {
        this.schema = this.getSchema().agGroups;
      } else {
        this.schema = this.getSchema().forestGroups;
      }
      this.practiceSchema = this.getSchema().practiceSchema;
      this.unitSchema = this.getSchema().unitSchema;
    },
    loadSiteGraphics(url, insightlyIds) {
      return new Promise((resolve, reject) => {
        const query = this.siteLayer.createQuery();
        query.where = `insightlyid IN (${insightlyIds.map((insightlyId) => `'${insightlyId}'`).join(', ')})`;
        this.siteLayer.queryFeatures(query).then((results) => {
          this.managementPlan.siteGraphics = [];
          results.features.forEach((graphic) => this.managementPlan.siteGraphics.push(graphic));
          resolve();
        }).catch((exception) => {
          console.error('exception: ', exception);
          reject(exception);
        });
      });
    },
    loadSiteObjects(siteGraphics) {
      return new Promise((resolve) => {
        (async () => {
          this.managementPlan.siteObjects = [];
          const sites = siteGraphics.map((siteGraphic) => siteGraphic);
          let siteGraphic = sites.pop();
          while (siteGraphic) {
            await api.get(`/site/${siteGraphic.attributes.insightlyid}`).then(async (siteResponse) => {
              const siteObject = siteResponse.data;
              siteObject.siteGraphic = siteGraphic;
              await api.get(`/sitetaxlot/site/${siteObject.Id}`).then(async (siteTaxlotResponse) => {
                siteObject.taxlotObjects = siteTaxlotResponse.data;
                await api.get(`/sitetrs/site/${siteObject.Id}`).then(async (siteTRSResponse) => {
                  siteObject.trsObjects = siteTRSResponse.data;
                  this.managementPlan.siteObjects.push(siteObject);
                }).catch((exception) => {
                  console.error(`Error fetching site trs '${siteObject.Id}'`);
                  console.error(exception);
                });
              }).catch((exception) => {
                console.error(`Error fetching site taxlots '${siteObject.Id}'`);
                console.error(exception);
              });
            }).catch((exception) => {
              console.error(`Error fetching site '${siteGraphic.attributes.insightlyid}'`);
              console.error(exception);
            });
            siteGraphic = sites.pop();
          }

          resolve();
        })();
      });
    },
    loadCoordinatesLatLong(siteGraphics) {
      return new Promise((resolve, reject) => {
        loadModules(
          ['esri/geometry/coordinateFormatter', 'esri/geometry/projection', 'esri/geometry/SpatialReference'],
        ).then(([coordinateFormatter, projection, SpatialReference]) => {
          coordinateFormatter.load().then(() => {
            projection.load().then(() => {
              const values = [];
              siteGraphics.forEach((siteGraphic) => {
                let value;
                if (!siteGraphic.geometry.centroid.spatialReference.isWGS84) {
                  value = coordinateFormatter.toLatitudeLongitude(
                    projection.project(siteGraphic.geometry.centroid, SpatialReference.WGS84),
                    'dms',
                    0,
                  );
                } else {
                  value = coordinateFormatter.toLatitudeLongitude(siteGraphic.geometry.centroid, 'dms', 0);
                }
                value = value.replace('N', ' N').replace('E', ' E').replace('S', ' S').replace('W', ' W')
                  .split(' ');
                values.push(`${value[0]}°${value[1]}'${value[2]}"${value[3]}, ${value[4]}°${value[5]}'${value[6]}"${value[7]}`);
              });
              resolve(values.join(', '));
            }).catch((exception) => {
              console.error(exception);
              reject(exception);
            });
          }).catch((exception) => {
            console.error(exception);
            reject(exception);
          });
        }).catch((exception) => {
          console.error(exception);
          reject(exception);
        });
      });
    },
    loadCoordinatesUTM(siteGraphics) {
      return new Promise((resolve, reject) => {
        loadModules(
          ['esri/geometry/coordinateFormatter', 'esri/geometry/projection', 'esri/geometry/SpatialReference'],
        ).then(([coordinateFormatter, projection, SpatialReference]) => {
          coordinateFormatter.load().then(() => {
            projection.load().then(() => {
              const values = [];
              siteGraphics.forEach((siteGraphic) => {
                let value;
                if (!siteGraphic.geometry.centroid.spatialReference.isWGS84) {
                  value = coordinateFormatter.toUtm(
                    projection.project(siteGraphic.geometry.centroid, SpatialReference.WGS84),
                    'latitude-band-indicators',
                    true,
                  );
                } else {
                  value = coordinateFormatter.toUtm(siteGraphic.geometry.centroid, 'latitude-band-indicators', true);
                }
                values.push(value);
              });
              resolve(values.join(', '));
            });
          });
        }).catch((exception) => {
          console.error(exception);
          reject(exception);
        });
      });
    },
    loadLookups(insightlyIds) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('SiteAssessment/fetchTualatinContacts').then(() => {
          this.$store.dispatch('ManagementPlan/fetchTargetSeasons').then(() => {
            this.$store.dispatch('ManagementPlan/fetchPracticeTypes').then(() => {
              this.$store.dispatch('ManagementPlan/updateAssessmentTextInIntroduction', insightlyIds).then(() => {
                this.lookupCleanup();
                resolve();
              }).catch((exception) => {
                console.error('Error updating assesment text in introduction');
                console.error(exception);
                reject(exception);
              });
            }).catch((exception) => {
              console.error('Error fetching practice types');
              console.error(exception);
              reject(exception);
            });
          }).catch((exception) => {
            console.error('Error fetching target seasons');
            console.error(exception);
            reject(exception);
          });
        }).catch((exception) => {
          console.error('Error fetching contacts');
          console.error(exception);
          reject(exception);
        });
      });
    },
    openPracticeModal() {
      this.currentPractice = this.initPractice();
      this.checkRequiredPracticeFields();
      this.$bvModal.show('practiceModal');
    },
    addPractice() {
      this.$store.dispatch('ManagementPlan/addPracticeToCurrentPlan', this.currentPractice);
      this.$bvModal.hide('practiceModal');
      this.updateTable();
    },
    cancelPractice() {
      this.currentPractice = this.initPractice();
      this.$bvModal.hide('practiceModal');
    },
    editPractice(row) {
      // the row is actually from this.currentVisiblePractices, and not managementPlan.managementRecommendations.practices
      this.currentPractice = this.cloneObject(row.item);
      this.checkRequiredPracticeFields();
      this.$bvModal.show('practiceModal');
    },
    updatePractice() {
      this.$store.dispatch('ManagementPlan/updatePracticeToCurrentPlan', this.currentPractice);
      this.currentPractice = this.initPractice();
      this.$bvModal.hide('practiceModal');
      this.updateTable();
    },
    deletePractice(row) {
      this.$store.dispatch('ManagementPlan/deletePracticeToCurrentPlan', row.item);
      this.currentPractice = this.initPractice();
    },
    updateTable() {
      // force a refresh on the table.  The data is getting updated but for some reason
      // the UI does not repaint w/o this call
      this.$root.$emit('bv::refresh::table', 'practiceTable');
    },
    // this should be extracted out to a mixin
    cloneObject(sourceObj) {
      const newObj = {};
      Object.assign(newObj, sourceObj);
      return newObj;
    },
    initPractice() {
      return {
        surrogateId: new Date().getTime(),
        targetYear: null,
        unitsFields: null,
        acres: null,
        notes: null,
        practiceTypeId: null,
        targetSeasonId: null,
      };
    },
    submitPlan(section) {
      if (this.checkRequiredPlanFields()) {
        this.activeTabValid = true;
        const firstSiteId = this.managementPlan.sites[0].insightlyId;
        this.$store.dispatch('ManagementPlan/updateUnitDetailsOnManagementPlan', this.currentUnits).then(() => {
          this.$store.dispatch('ManagementPlan/updateManagementPlan', this.managementPlan).then(() => {
            if (!this.submitError) {
              if (section.id === 'managementRecommendations') {
                this.$store.dispatch('ManagementPlan/initManagementPlan');
                this.$router.push({
                  path: `/site/${firstSiteId}/managementPlans`,
                });
              } else {
                // save was successful and we are staying on the page,
                // show alert here and reset the submit success back to false
                // to prevent a success message on the list page if the user navigates away from here
                this.$store.dispatch('ManagementPlan/setSubmitSuccess', false);
                this.showSuccessAlert();
              }
            }
          });
        });
      } else {
        this.activeTabValid = false;
      }
    },
    addNewUnit() {
      if (!this.currentUnits) {
        this.currentUnits = [];
      }
      this.currentUnits.push({ details: this.initialUnitDetails, tempId: this.currentUnits.length });
      // we have to wait for nextTick before scrolling down to the new element
      this.$nextTick(() => {
        this.$refs.unitInput[this.currentUnits.length - 1].scrollIntoView();
      });
    },
    getInsightlySiteUrl(insightlyId) {
      return `${this.config.insightly.siteUrl}${insightlyId}`;
    },
    isNewPractice(practice) {
      const recommendations = this.managementPlan.managementRecommendations;
      const index = recommendations.practices.findIndex((e) => e.surrogateId === practice.surrogateId);
      return index < 0;
    },
  },
};
</script>
